import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PagesComponent } from "./pages/pages.component";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslocoRootModule } from "./transloco-root.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RegistrationComponent } from "./registration/registration.component";
import { ExampleMonouseComponent } from "./tables-custom-actions/example-table-component.component";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { FooterComponent } from "./components/footer/footer.component";
import { MenuComponent } from "./components/menu/menu.component";
import { WhoComponent } from "./pages/who/who.component";
import { ServicesComponent } from "./pages/services/services.component";
import { NewsComponent } from "./pages/news/news.component";
import { SayComponent } from "./pages/say/say.component";
import { JoinComponent } from "./pages/join/join.component";
import { ContactsComponent } from "./pages/contacts/contacts.component";
import { HomeComponent } from "./pages/home/home.component";
import { FindComponent } from "./pages/find/find.component";
import { BandoComponent } from "./pages/bando/bando.component";
import { InnovazioneRicercaComponent } from "./pages/cerca-bando/innovazione-ricerca/innovazione-ricerca.component";
import { DigitaleIntelligenzaArtificialeComponent } from "./pages/cerca-bando/digitale-intelligenza-artificiale/digitale-intelligenza-artificiale.component";
import { LoginComponent } from "./auth/login/login.component";
import { AuthComponent } from "./auth/auth.component";
import { ContainerComponent } from "./manager/container.component";
import { HeaderComponent } from "./components/header/header.component";
import { ProjectCardComponent } from "./manager/projectCard.component";
import { CompleteComponent } from "./complete/complete.component";
import { ProjectComponent } from "./manager/project/project.component";
import { BandiCardComponent } from "./manager/bandiCard.component";
import { BandoDetailsComponent } from "./manager/bandoDetails/bando-details.component";
import { CalendarComponent } from "./components/calendar/calendar.component";
import { ProfileComponent } from "./manager/profile/profile.component";
import { UniversalCrudComponent } from "./components/universal-crud/universal-crud.component";
import { LoaderComponent } from "./components/loader/loader.component";
import { MessageComponent } from "./components/message/message.component";
import { ButtonComponent } from "./components/button/button.component";
import { SelectComponent } from "./components/select/select.component";
import { InputComponent } from "./components/input/input.component";
import { CheckboxComponent } from "./components/checkbox/checkbox.component";
import { CardComponent } from "./components/card/card.component";
import { TimePickerComponent } from "./components/time-picker/time-picker.component";
import { ModalComponent } from "./components/modal/modal.component";
import { TableComponent } from "./components/table/table.component";
import { TableRowComponent } from "./components/tablerow/tablerow.component";
import { ClickOutsideComponent } from "./components/click_outside/click_outside.component";
import { TooltipComponent } from "./components/tooltip/tooltip.component";
import { TableColumnDirective } from "./service/tablecolumn.directive";
import { MobileTableRowComponent } from "./components/tablerow/mobiletablerow.component";
import { MiniCalendarComponent } from "./components/mini-calendar/mini-calendar.component";
import { PaginatorComponent } from "./components/paginator/paginator.component";
import { PricingComponent } from "./pages/pricing/pricing.component";
import { ImportNoticeCSVComponent } from "./tables-custom-actions/import-notice-csv.component";
import { UniversalDetailsComponent } from "./components/universal-details/universal-details.component";
import { TabsComponent } from "./components/tabs/tabs.component";
import { TabComponent } from "./components/tabs/tab/tab.component";
import { CatalogCardComponent } from "./manager/catalogCard.component";
import { CreateNoticeComponent } from "./tables-custom-actions/create-notice.component";
import { RouteReuseStrategy } from "@angular/router";
import { CustomReuseStrategy } from "./reuse";
import { UniversalCreateComponent } from "./components/universal-create/universal-create.component";
import { CustomCatalogFilterComponent } from "./tables-custom-actions/custom-catalog-filter";
import { HowComponent } from "./components/how/how.component";
import { OpenModalBookingComponent } from "./tables-custom-actions/open-modal-booking.component";
import { CatalogCompaniesComponent } from "./manager/catalogCompanies/catalogCompanies.component";
import { NoticeVerificationAdminComponent } from "./tables-custom-actions/notice-verification-admin.component";
import { ImpreseStartupComponent } from './pages/piani/imprese-startup/imprese-startup.component';
import { EntiPubbliciComponent } from './pages/piani/enti-pubblici/enti-pubblici.component';
import { PartnerComponent } from './pages/piani/partner/partner.component';
import { CookiePolicyComponent } from "./components/cookie-policy/cookie-policy.component";
import { PageNoticeVerificationAdminComponent } from "./tables-custom-actions/page-notice-verification-admin.component";
import { PreferenceComponent } from "./manager/preference/preference.component";
import { DownloadRequestsCSVComponent } from "./tables-custom-actions/download-requests-csv.component";
import { ApprovePartnerComponent } from "./tables-custom-actions/approve-partner.component";
import { ForceResetEmailComponent } from "./tables-custom-actions/force-reset-email.component";
@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    LoginComponent,
    RegistrationComponent,
    ExampleMonouseComponent,
    RecoveryPasswordComponent,
    ChangePasswordComponent,
    FooterComponent,
    MenuComponent,
    WhoComponent,
    ServicesComponent,
    NewsComponent,
    SayComponent,
    JoinComponent,
    ContactsComponent,
    HomeComponent,
    CustomCatalogFilterComponent,
    FindComponent,
    InnovazioneRicercaComponent,
    DigitaleIntelligenzaArtificialeComponent,
    BandoComponent,
    AuthComponent,
    ContainerComponent,
    HeaderComponent,
    ProjectCardComponent,
    ProjectComponent,
    CompleteComponent,
    BandiCardComponent,
    BandoDetailsComponent,
    CalendarComponent,
    ProfileComponent,
    UniversalCrudComponent,
    LoaderComponent,
    MessageComponent,
    ButtonComponent,
    SelectComponent,
    InputComponent,
    CheckboxComponent,
    CardComponent,
    TimePickerComponent,
    ModalComponent,
    TableComponent,
    TableRowComponent,
    MobileTableRowComponent,
    ClickOutsideComponent,
    TooltipComponent,
    TableColumnDirective,
    MiniCalendarComponent,
    PaginatorComponent,
    PricingComponent,
    ImportNoticeCSVComponent,
    UniversalDetailsComponent,
    TabsComponent,
    TabComponent,
    CatalogCardComponent,
    CreateNoticeComponent,
    UniversalCreateComponent,
    OpenModalBookingComponent,
    HowComponent,
    CatalogCompaniesComponent,
    NoticeVerificationAdminComponent,
    ImpreseStartupComponent,
    EntiPubbliciComponent,
    PartnerComponent,
    CookiePolicyComponent,
    PageNoticeVerificationAdminComponent,
    PreferenceComponent,
    DownloadRequestsCSVComponent,
    ApprovePartnerComponent,
    ForceResetEmailComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslocoRootModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi()), { provide: RouteReuseStrategy, useClass: CustomReuseStrategy }],
})
export class AppModule { }
